angular.module('unica_user.user_controllers', [])

.controller('UserBasicController',
	function(
		$rootScope, $scope,
		UtilityService, UserListService
	) {

	$scope.forms = {};

	$scope.agencyDataRequired = false;
	$scope.roleChanged = function() {
		if ( $rootScope.userData.role === 'agency' ) {
			$scope.agencyDataRequired = true;
		} else {
			$scope.agencyDataRequired = false;
		}
	};

	$scope.parentIdRequired = false;
	$rootScope.parUsers     = {};

	$scope.checkParent = function() {

		if ( $rootScope.userData.role === 'zone_manager' ||
			 $rootScope.userData.role === 'agency' ||
			 $rootScope.userData.role === 'agent' ||
			 $rootScope.userData.role === 'op' ||
			 $rootScope.userData.role === 'collaborator' ) {

			$scope.parentIdRequired = true;

			if ( $rootScope.userData.role === 'agent' || $rootScope.userData.role === 'collaborator' || $rootScope.userData.role === 'op' ) {
				$scope.agencyDataRequired = true;
			} else {
				$scope.agencyDataRequired = false;
			}

		} else {
			$scope.parentIdRequired = false;
		}
	};

	$scope.searchText = '';

	$scope.searchParentUser = function(query) {

		if ( $rootScope.userData.role === 'zone_manager' ||
			 $rootScope.userData.role === 'agency' ||
			 $rootScope.userData.role === 'agent' ||
			 $rootScope.userData.role === 'op' ||
			 $rootScope.userData.role === 'collaborator' ) {

			if ( $rootScope.userData.role === 'collaborator' || $rootScope.userData.role === 'agent' || $rootScope.userData.role === 'op' ) {
				var role     = 'agency',
					sub_role = 'agency';
			} else if ( $rootScope.userData.role === 'agency' && $rootScope.userData.sub_role === 'agency' ) {
				var role     = 'zone_manager',
					sub_role = 'zone_manager';
			} else if ( $rootScope.userData.role === 'zone_manager' ) {
				var role     = 'area_manager',
					sub_role = 'area_manager';
			}

			return UserListService
						.listByRoleAndSearch(role, sub_role, query)
						.then(function(users) {
							if ( users ) {
								var tmp = [];

								angular.forEach(users, function(user, key) {
									if ( user.role === 'agency' && user.agency_name !== '' && user.agency_name != null ) {
										user.label = user.agency_name;
									} else {
										user.label = user.first_name + ' ' + user.last_name;
									}
									tmp.push(user);
								});

								return tmp;
							}

							return [];
						});
		}
	};

	$scope.selectedParentUser = function(parentUser) {
		if ( parentUser ) {
			$rootScope.userData.parent_id = parentUser.id;
			angular.forEach( parentUser, function(item, index) {
				if ( index.substr(0, 7) === 'agency_' ) {
					$rootScope.userData[index] = item;
				}
			});
		} else {
			$rootScope.userData.parent_id = null;
		}
	};








	$scope.nets = {};
	$scope.loadNets = function() {
		UtilityService
			.listNets()
			.then(function(data) {
				if (!data.error) {
					$scope.nets = data;
				} else {
					$rootScope.manageError(data);
				}
			}, function(data) {
				$rootScope.manageError(data);
			});
	};

	$scope.structures = {};
	$scope.loadStructures = function() {
		UtilityService
			.listStructures()
			.then(function(data) {
				if (!data.error) {
					$scope.structures = data;
				} else {
					$rootScope.manageError(data);
				}
			}, function(data) {
				$rootScope.manageError(data);
			});
	};

	$scope.zones = {};
	$scope.loadZones = function() {
		UtilityService
			.listZones()
			.then(function (data) {
				if (!data.error) {
					$scope.zones = data;
				} else {
					$rootScope.manageError(data);
				}
			}, function (data) {
				$rootScope.manageError(data);
			});
	};

	$scope.province = {};
	$scope.loadProvinces = function() {
		UtilityService
			.listProvince()
			.then(function(data) {
				if (!data.error) {
					$scope.province = data;
				} else {
					$rootScope.manageError(data);
				}
			}, function(data) {
				$rootScope.manageError(data);
			});
	};

});